import { Component, OnInit } from '@angular/core';
import * as moment from 'moment'
import {DateAdapter} from '@angular/material';

@Component({
  selector: 'app-agris-cotiz-detalle-renovar-dialog',
  templateUrl: './agris-cotiz-detalle-renovar-dialog.component.html',
  styleUrls: ['./agris-cotiz-detalle-renovar-dialog.component.scss', '../../common/agris-common-styles.scss']
})
export class AgrisCotizDetalleRenovarDialogComponent implements OnInit {

  fechaVencimiento = moment().add(15, 'days').toDate();
  min = moment().add(1, 'days').toDate();
  max = moment().add(30, 'days').toDate();

  constructor(
    private dateAdapter: DateAdapter<Date>,
  ) {
    this.dateAdapter.setLocale('en-GB');
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-cotizacion-detalle-page/agris-cotiz-detalle-renovar-dialog/agris-cotiz-detalle-renovar-dialog.component.ts